var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.335 0C17.723 0 20 2.378 20 5.917V14.084C20 17.623 17.723 20 14.334 20H5.666C2.277 20 0 17.623 0 14.084V5.917C0 2.378 2.277 0 5.666 0H14.335ZM6.841 7.399C5.407 7.399 4.24 8.566 4.24 10C4.24 11.435 5.407 12.602 6.841 12.602C8.013 12.602 8.995 11.818 9.319 10.75H11.431V11.852C11.431 12.266 11.767 12.602 12.181 12.602C12.595 12.602 12.931 12.266 12.931 11.852V10.75H14.261V11.852C14.261 12.266 14.597 12.602 15.011 12.602C15.425 12.602 15.761 12.266 15.761 11.852V10C15.761 9.586 15.425 9.25 15.011 9.25H9.319C8.995 8.183 8.013 7.399 6.841 7.399ZM6.8411 8.8989C7.4481 8.8989 7.9431 9.3929 7.9431 10.0009C7.9431 10.6079 7.4481 11.1019 6.8411 11.1019C6.2341 11.1019 5.7391 10.6079 5.7391 10.0009C5.7391 9.3929 6.2341 8.8989 6.8411 8.8989Z",
    fill: "#A9C8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.57b9afa6.svg";
export { ForwardRef as ReactComponent };